<template>
  <div>
    12121 {{ aa }}
    <img src="@/assets/img/index/icon/function_1price.svg" />
  </div>
</template>
<script>
export default {
  name: "Test",
  data () {
    return {
      aa: 'aa'
    }
  },
  created () {},
  methods: {}
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/test/test.vue